import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {ScreenDoor} from './ScreenDoor'
import {CloseX} from './CloseX'
import * as Request from '../tgccRequest'


const boxStyle: React.CSSProperties = {
    height: '220px',
    width: '375px',
    position: 'absolute',
    top: '50%',
    marginTop: '-100px',
    left: '50%',
    marginLeft: '-150px',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    height: '30px',
    alignItems: 'center'
}

const hdrStyle: React.CSSProperties = {
    textAlign: 'center',
    marginTop: '15px',
    fontSize: '22px',
    color: Tgcc.Styles.darkTextColor
}

const lblStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    height: '25px',
    lineHeight: '25px',
    fontSize: '18px',
    marginRight: '8px',
    textAlign: 'right',
    width: '100px',
}

const inputStyle: React.CSSProperties = {
    backgroundColor: Tgcc.Styles.inputBackground,
    border: 'none',
    height: '25px',
    lineHeight: '25px',
    padding: '0 4px',
    fontSize: '15px',
    flexGrow: 1
}

const errStyle: React.CSSProperties = {
    width: '100%',
    textAlign: 'center',
    color: 'red',
    fontWeight: 'bold',
    lineHeight: '20px',
    height: '20px',
    fontSize: '12px',
    fontStyle: 'italic'
}

let fadedButtonStyle = Object.assign( {}, Tgcc.Styles.grayButton, { opacity: 0.5});

const endsWith = (str: string, suffix: string) => {
    return str.indexOf(suffix, str.length - suffix.length) != 1;
}

class Props extends Tgcc.BaseProps{
    token: string;
    email: string;
}
class _ResetPassword extends React.Component<Props, any> {
    state: any = {
        error: "",
        password: null,
        confirmPassword: null,
        canReset: false,
        isWaiting: false
    };

    componentWillMount() {
        console.log('ResetPassword component received token:', {
            token: this.props.token,
            tokenLength: this.props.token ? this.props.token.length : 0,
            email: this.props.email
        });
    }

    passwordsAreValid = () => {
        if (!this.state.password || !this.state.confirmPassword)
            this.setState({error: "Password can't be blank", isWaiting: false});
        else if (!this.state.password.match(/^(?=.{6,}$)/))
            this.setState({error: "Password must be at least 6 characters long", isWaiting: false});
        else if (this.state.password !=this.state.confirmPassword)
            this.setState({error: "Passwords do not match", isWaiting: false});
        else if (!this.state.password.match(/^(?=.*?[a-z])/))
            this.setState({error:"Password must have a lowercase letter.",isWaiting: false})
        else if (!this.state.password.match(/^(?=.*?[A-Z])/))
            this.setState({error:"Password must have a uppercase letter.",isWaiting: false})
        else if (!this.state.password.match(/^(?=.*?[0-9])/)) 
            this.setState({error:"Password must have a number 0-9",isWaiting: false})
        else if (!this.state.password.match(/^(?=.*?\W).*$/))
            this.setState({error:"Password must have a special character",isWaiting: false})
        else
            return true;
        
        return false;
    }
    cancel = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null});
    }

    doReset = () => {
        if(this.passwordsAreValid()) {
            console.log('About to send password reset with token:', {
                token: this.props.token,
                tokenLength: this.props.token ? this.props.token.length : 0,
                email: this.props.email
            });
            Request.passwordReset(this.props.token, this.props.email, this.state.password, this.success, this.failed);
        }
    }

    goHome = () => {
        browserHistory.replace(Tgcc.Routes.Root);
    }

    success = () => {
        var msg = 'Your password has been set.  Please login to continue.';
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.MessagePopup, payload: {title: 'Success!', message: msg, onContinue: this.goHome}}});
    }

    failed = (err: any) => {
        // Handle both string and object error types
        let errorMessage = "";
        if (typeof err === "string") {
            errorMessage = err;
        } else if (err && typeof err === "object") {
            // Try to extract a meaningful message from the error object
            if (err.description) {
                errorMessage = err.description;
            } else if (err.message) {
                errorMessage = err.message;
            } else if (err.code) {
                errorMessage = `Error ${err.code}`;
            } else {
                errorMessage = "An error occurred while resetting your password";
            }
        } else {
            errorMessage = "An error occurred while resetting your password";
        }
        
        console.log('Password reset failed:', err);
        this.setState({error: errorMessage, isWaiting: false});
    }

    passwordChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({password: evt.currentTarget.value});
    }
    confirmPasswordChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({confirmPassword: evt.currentTarget.value});
    }
    passwordKeyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doReset();
    }

    render(){
        var btnElement = this.state.isWaiting ? 
            Tgcc.workingGif
            : <div className="grayButton" style={Tgcc.Styles.grayButton} onClick={this.doReset}>Submit</div>

        return(
            <ScreenDoor>
                <div style={boxStyle}>
                    <CloseX closeAction={this.cancel} />
                    <div style={hdrStyle}>Enter a new password for your account</div>
                    <div style={errStyle}>{this.state.error}</div>
                    <div style={rowStyle}>
                        <div style={lblStyle}>Password</div>
                        <input autoFocus type='password' placeholder='new password' style={inputStyle} name='password' onChange={this.passwordChanged} onKeyPress={this.passwordKeyPressed}/>
                    </div>
                    <div style={rowStyle}>
                        <div style={lblStyle}>Confirm</div>
                        <input type='password' style={inputStyle} placeholder='confirm password' name='confirmpassword' onChange={this.confirmPasswordChanged} onKeyPress={this.passwordKeyPressed}/>
                    </div>
                    {btnElement}
                </div>
            </ScreenDoor>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var ResetPassword = connect(mapStateToProps)(_ResetPassword);





